import React from 'react';
import checkmark from '../../../../assets/checkmark.svg';
import rsmCheckmark from '../../../../assets/rsm-checkmark.svg';
import { isEnvRSM } from '../../../../common/utilities/_helpers';
import { IPlanFeatureModel } from '../../../../interfaces';

import { Button } from '../../../../common/buttons';
import { useResourceContext } from '../../../../common/resource-context';
import './FeatureList.scss';

export interface FeatureListProps {
  featureList: IPlanFeatureModel[];
  isLeaseQueryPlan: boolean;
}

export default function FeatureList({
  featureList,
  isLeaseQueryPlan,
}: FeatureListProps): JSX.Element {
  const isRSM = isEnvRSM();
  const resources = useResourceContext();

  const handleBuyNow = () => {
    window.open(
      resources.text('LeaseQueryEnterprisePricingUrl'),
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <div className="features-container">
      {featureList.map((feature: IPlanFeatureModel) => {
        return (
          <div className="tier-feature" key={feature.id}>
            <span className="check-mark">
              <img src={isRSM ? rsmCheckmark : checkmark} alt="checkmark" />
            </span>
            <span className="feature-item">{feature.description}</span>
          </div>
        );
      })}
      {isLeaseQueryPlan && (
        <div className="button-container">
          <div className="buy-now-wrapper">
            <Button
              buttonType="positive-green"
              buttonText={resources.text('BuyNow_LeaseQuery')}
              type="button"
              onClick={handleBuyNow}
              classes="buy-now-button"
            />
          </div>
          <a
            href={resources.text('LeaseQueryEnterpriseDemoUrl')}
            target="_blank"
            rel="noreferrer noopener"
          >
            {resources.text('ScheduleDemo_LeaseQuery')}
          </a>
        </div>
      )}
    </div>
  );
}
